import React from 'react'

import { useParams } from 'react-router'

import { MealKitDishDetailsFragment, useOneMealKitDishWithSlugQuery } from '@hooks/api'
import { MealKitPDP, DetailPageWrapper } from '@organisms/index'
import { ProductStatusEnum } from '@uctypes/api/globalTypes'
import { SearchEngineOptimization, SearchEngineOptimizationParams } from '@utility/SearchEngineOptimization'

const seo = (dish?: MealKitDishDetailsFragment): SearchEngineOptimizationParams => ({
  name: 'UCOOK Meal Kit Dish',
  title: `${dish?.name ?? 'Awesome'} Recipe & Ingredients | UCOOK`,
  meta: [{
    name: 'description',
    content: `${dish?.description ?? 'Amazing Recipe'}`,
  }, {
    name: 'keywords',
    content: `${dish?.name ?? 'Awesome'} Recipe,${dish?.name ?? 'Awesome'} Ingredients,${dish?.name ?? 'Awesome'} delivery`,
  }, {
    name: 'robots',
    content: 'index,follow',
  }],
})

export function MealKitDetails(): JSX.Element {

  const { slug } = useParams<{ slug: string }>()
  const { data, loading, error } = useOneMealKitDishWithSlugQuery({
    variables: {
      slug,
      status: [ProductStatusEnum.PUBLISHED],
    },
  })

  const dish = data?.dish

  return (
    <DetailPageWrapper
      loading={loading && !dish}
      error={error}
      pdp={<MealKitPDP dish={dish} slug={slug} loading={loading} />}
      seo={<SearchEngineOptimization seo={seo(dish)} />} />
  )
}
